"use no memo";

import { useEffect } from 'react';
import { isSessionStorageAllowed } from '@local/utils';
import {
  ExperienceType,
  EXPERIENCE_TYPE_STORAGE_KEY,
  getExperienceFromUrl,
} from 'helpers/routes';

// save experience type to session storage
export function persistExperienceToSessionStorage(
  experience: ExperienceType | undefined
): void {
  if (
    !experience ||
    typeof window === 'undefined' ||
    !isSessionStorageAllowed()
  )
    return;
  sessionStorage.setItem(EXPERIENCE_TYPE_STORAGE_KEY, experience);
}

// save experience type to session storage when url changes
export function usePersistExperience(): void {
  const urlExperience = getExperienceFromUrl();
  useEffect(() => {
    persistExperienceToSessionStorage(urlExperience);
  }, [urlExperience]);
}
